import { HubSpotCmpScript } from "@/core/consent/sources/hubspot/HubSpotCmpScript";
import {
  clearHubSpotChoice,
  createHubSpotSource,
  reopenHubSpotBanner,
} from "@/core/consent/sources/hubspot/hubspot.source";
import {
  HUBSPOT_CONSENT_NOTICE_VERSION,
  resolveHubSpotNoticeLanguage,
} from "@/core/consent/sources/hubspot/hubspotNotice.version";

/**
 * The mounted banner — the ONE place that names a CMP. Everything else in the
 * app, the composition root included, sees only these six names: a
 * `ConsentSource` that emits the visitor's answer, the component that renders
 * the banner, the reopen, the forget, the notice generation the answer is
 * recorded under, and the language that notice is presented in.
 *
 * HubSpot today (T-3834): its choice cookie is root-domain scoped, so consent
 * stays continuous with the HubSpot-hosted landing pages under the same
 * domain. c15t stays in the tree (`sources/c15t`), exported and tested; to
 * swap back, point these five exports at `createC15tSource`, `LazyC15tCmp`,
 * `reopenC15tPreferences`, a c15t forget, `CONSENT_NOTICE_VERSION`, and
 * `resolveC15tNoticeLanguage`. The
 * notice-version lockstep gate follows `BANNER_NOTICE_VERSION` from here, so
 * the backend constant must move with it.
 */
export const createBannerSource = createHubSpotSource;

export const ConsentBanner = HubSpotCmpScript;

export const reopenBanner = reopenHubSpotBanner;

export const clearBannerDecision = clearHubSpotChoice;

export const BANNER_NOTICE_VERSION = HUBSPOT_CONSENT_NOTICE_VERSION;

/**
 * The language the mounted banner presents its notice in, for the route the
 * visitor is on. Recorded with each decision as the notice's language — which
 * for HubSpot is English whatever the route, and for c15t is the route locale.
 */
export const resolveBannerNoticeLanguage: (routeLanguageCode: string) => string =
  resolveHubSpotNoticeLanguage;
